<template>
  <div :class="['icon-wrapper', `icon-${name}`, `c-color-${color}`, `${fillMode}-mode`]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  fillMode: 'fill' | 'stroke'
  name: string
}>()
</script>

<style lang="scss">
@import './wrapper.scss';
</style>
